/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonIdAttachmentsQueryResponse,
  GetApiV1PersonIdAttachmentsPathParams,
  GetApiV1PersonIdAttachments401,
  GetApiV1PersonIdAttachments404,
  GetApiV1PersonIdAttachments500,
} from "../../types/personDocumentsController/GetApiV1PersonIdAttachments.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonIdAttachments } from "../../clients/personDocumentsController/getApiV1PersonIdAttachments.ts";

export const getApiV1PersonIdAttachmentsQueryKey = (
  id: GetApiV1PersonIdAttachmentsPathParams["id"],
) => [{ url: "/api/v1/person/:id/attachments", params: { id: id } }] as const;

export type GetApiV1PersonIdAttachmentsQueryKey = ReturnType<
  typeof getApiV1PersonIdAttachmentsQueryKey
>;

export function getApiV1PersonIdAttachmentsQueryOptions(
  id: GetApiV1PersonIdAttachmentsPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonIdAttachmentsQueryKey(id);
  return queryOptions<
    GetApiV1PersonIdAttachmentsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdAttachments401
      | GetApiV1PersonIdAttachments404
      | GetApiV1PersonIdAttachments500
    >,
    GetApiV1PersonIdAttachmentsQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonIdAttachments(id, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Lista os anexos de documentos de matrícula da pessoa. **(Requer Authorization para autenticação)**
 * @summary Listar anexos de matrícula da pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/attachments}
 */
export function useGetApiV1PersonIdAttachments<
  TData = GetApiV1PersonIdAttachmentsQueryResponse,
  TQueryData = GetApiV1PersonIdAttachmentsQueryResponse,
  TQueryKey extends QueryKey = GetApiV1PersonIdAttachmentsQueryKey,
>(
  id: GetApiV1PersonIdAttachmentsPathParams["id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonIdAttachmentsQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonIdAttachments401
          | GetApiV1PersonIdAttachments404
          | GetApiV1PersonIdAttachments500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1PersonIdAttachmentsQueryKey(id);

  const query = useQuery(
    {
      ...getApiV1PersonIdAttachmentsQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonIdAttachments401
      | GetApiV1PersonIdAttachments404
      | GetApiV1PersonIdAttachments500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
